module.exports = __webpack_public_path__ + "h5/img/huangguan_1.be5fb143.png";